import { Trans } from '@lingui/macro';
import { useState, useCallback, useRef, useEffect } from 'react';

import './style.scss';

const TextArea = ({ label, onChange, value, disabled = false }) => {
    const ref = useRef();
    const [active, setActive] = useState(false);

    const onFocus = () => {
        setActive(true);
    }

    const onBlur = useCallback(() => {
        if (!value.length) {
            setActive(false);
        }
    }, [value])

    const onChangeCapture = (e) => {
        onChange(e.target.value);
    }

    useEffect(() => {
        if (ref.current) {
            ref.current.style.height = "0px";
            const scrollHeight = ref.current.scrollHeight;
            
            if (scrollHeight !== 0) {
                ref.current.style.height = scrollHeight + "px";
            } else if (scrollHeight < 150) {
                ref.current.style.height = scrollHeight + 28 + "px";
            } else {
                ref.current.style.height = '150px';
            }
        }
    }, [ref, value])

    return (
        <div className={`textarea ${active ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
            <h6><Trans id={label} values={label}/></h6>
            <textarea disabled={disabled} rows={1} onChange={onChangeCapture} onFocus={onFocus} onBlur={onBlur} ref={ref}></textarea>
        </div>
    )
}

export default TextArea;